import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-clouddrive",
  "use": "icon-clouddrive-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 1024 1024\" id=\"icon-clouddrive\"><title></title><path d=\"M859.62,434.55A154.52,154.52,0,0,0,626.12,314.61c-26.67-104.35-121.31-181.5-234-181.5-133.37,0-241.49,108.12-241.49,241.49a241.77,241.77,0,0,0,8.21,62.6C67.44,467.61,1.51,553.84,1.51,655.48h0c0,127,103,230,230,230h564c127,0,230-103,230-230h0C1025.51,550.71,955.44,462.31,859.62,434.55ZM503.51,750C384.8,750,280.66,687.69,222,594h95a256.41,256.41,0,0,0,373,0h95C726.35,687.69,622.21,750,503.51,750Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/clouddrive.svg
// module id = gJOM
// module chunks = 54